export enum AgreementsClassificationType {
  Offer = 'Offer',
  Legal = 'Legal',
}
